/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { GrowthHistoryDto } from '../models/growth-history-dto';
import { PageInfoDto } from '../models/page-info-dto';
import { productControllerCreate } from '../fn/product/product-controller-create';
import { ProductControllerCreate$Params } from '../fn/product/product-controller-create';
import { productControllerDelete } from '../fn/product/product-controller-delete';
import { ProductControllerDelete$Params } from '../fn/product/product-controller-delete';
import { productControllerFindById } from '../fn/product/product-controller-find-by-id';
import { ProductControllerFindById$Params } from '../fn/product/product-controller-find-by-id';
import { productControllerGetStats } from '../fn/product/product-controller-get-stats';
import { ProductControllerGetStats$Params } from '../fn/product/product-controller-get-stats';
import { productControllerSearch } from '../fn/product/product-controller-search';
import { ProductControllerSearch$Params } from '../fn/product/product-controller-search';
import { productControllerSearchGrowthHistory } from '../fn/product/product-controller-search-growth-history';
import { ProductControllerSearchGrowthHistory$Params } from '../fn/product/product-controller-search-growth-history';
import { productControllerUpdate } from '../fn/product/product-controller-update';
import { ProductControllerUpdate$Params } from '../fn/product/product-controller-update';
import { ProductDto } from '../models/product-dto';
import { ProductStatsDto } from '../models/product-stats-dto';

@Injectable({ providedIn: 'root' })
export class ProductService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `productControllerSearch()` */
  static readonly ProductControllerSearchPath = '/api/product';

  /**
   * 상품 목록 조회.
   *
   * 상품 목록을 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  productControllerSearch$Response(params: ProductControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<ProductDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = productControllerSearch(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 상품 목록 조회.
   *
   * 상품 목록을 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productControllerSearch(params: ProductControllerSearch$Params, context?: HttpContext): Observable<{
'items': Array<ProductDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.productControllerSearch$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<ProductDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<ProductDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `productControllerCreate()` */
  static readonly ProductControllerCreatePath = '/api/product';

  /**
   * 상품 등록.
   *
   * 새로운 상품을 등록합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productControllerCreate$Response(params: ProductControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductDto>> {
    const obs = productControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 상품 등록.
   *
   * 새로운 상품을 등록합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productControllerCreate(params: ProductControllerCreate$Params, context?: HttpContext): Observable<ProductDto> {
    const resp = this.productControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ProductDto>): ProductDto => r.body)
    );
  }

  /** Path part for operation `productControllerFindById()` */
  static readonly ProductControllerFindByIdPath = '/api/product/{id}';

  /**
   * 상품 상세 조회.
   *
   * 상품을 ID로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  productControllerFindById$Response(params: ProductControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductDto>> {
    const obs = productControllerFindById(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 상품 상세 조회.
   *
   * 상품을 ID로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productControllerFindById(params: ProductControllerFindById$Params, context?: HttpContext): Observable<ProductDto> {
    const resp = this.productControllerFindById$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ProductDto>): ProductDto => r.body)
    );
  }

  /** Path part for operation `productControllerDelete()` */
  static readonly ProductControllerDeletePath = '/api/product/{id}';

  /**
   * 상품 삭제.
   *
   * 상품을 삭제합니다. (소프트 삭제)
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  productControllerDelete$Response(params: ProductControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductDto>> {
    const obs = productControllerDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 상품 삭제.
   *
   * 상품을 삭제합니다. (소프트 삭제)
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productControllerDelete(params: ProductControllerDelete$Params, context?: HttpContext): Observable<ProductDto> {
    const resp = this.productControllerDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ProductDto>): ProductDto => r.body)
    );
  }

  /** Path part for operation `productControllerUpdate()` */
  static readonly ProductControllerUpdatePath = '/api/product/{id}';

  /**
   * 상품 수정.
   *
   * 상품 정보를 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productControllerUpdate$Response(params: ProductControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductDto>> {
    const obs = productControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 상품 수정.
   *
   * 상품 정보를 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productControllerUpdate(params: ProductControllerUpdate$Params, context?: HttpContext): Observable<ProductDto> {
    const resp = this.productControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ProductDto>): ProductDto => r.body)
    );
  }

  /** Path part for operation `productControllerGetStats()` */
  static readonly ProductControllerGetStatsPath = '/api/product/{id}/stats';

  /**
   * 상품 통계 조회.
   *
   * 상품의 판매 통계를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productControllerGetStats()` instead.
   *
   * This method doesn't expect any request body.
   */
  productControllerGetStats$Response(params: ProductControllerGetStats$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductStatsDto>> {
    const obs = productControllerGetStats(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 상품 통계 조회.
   *
   * 상품의 판매 통계를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productControllerGetStats$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productControllerGetStats(params: ProductControllerGetStats$Params, context?: HttpContext): Observable<ProductStatsDto> {
    const resp = this.productControllerGetStats$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ProductStatsDto>): ProductStatsDto => r.body)
    );
  }

  /** Path part for operation `productControllerSearchGrowthHistory()` */
  static readonly ProductControllerSearchGrowthHistoryPath = '/api/product/{id}/growth-history';

  /**
   * 상품별 성장 이력 조회.
   *
   * 특정 상품에 속한 모든 돼지의 성장 이력을 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productControllerSearchGrowthHistory()` instead.
   *
   * This method doesn't expect any request body.
   */
  productControllerSearchGrowthHistory$Response(params: ProductControllerSearchGrowthHistory$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<GrowthHistoryDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = productControllerSearchGrowthHistory(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 상품별 성장 이력 조회.
   *
   * 특정 상품에 속한 모든 돼지의 성장 이력을 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productControllerSearchGrowthHistory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productControllerSearchGrowthHistory(params: ProductControllerSearchGrowthHistory$Params, context?: HttpContext): Observable<{
'items': Array<GrowthHistoryDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.productControllerSearchGrowthHistory$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<GrowthHistoryDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<GrowthHistoryDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

}
